module.exports = __webpack_public_path__ + "img/speech_bubble.9fdcb4ae.png";